'use client';
import type { Assign } from '@ark-ui/react';
import { Avatar } from '@ark-ui/react';
import { type AvatarVariantProps, avatar } from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(avatar);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, Avatar.RootProviderProps>,
    AvatarVariantProps
  >
>(Avatar.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLDivElement,
  Assign<Assign<HTMLStyledProps<'div'>, Avatar.RootProps>, AvatarVariantProps>
>(Avatar.Root, 'root');

export const Fallback = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<'span'>, Avatar.FallbackProps>
>(Avatar.Fallback, 'fallback');

export const Image = withContext<
  HTMLImageElement,
  Assign<HTMLStyledProps<'img'>, Avatar.ImageProps>
>(Avatar.Image, 'image');

export { AvatarContext as Context } from '@ark-ui/react';
export type { AvatarStatusChangeDetails as StatusChangeDetails } from '@ark-ui/react';
